<template>
    <el-row class="welcome">
        <el-col :span="20">
               欢迎回来！{{userData.name}}  
               <!-- 培训方式：{{userData.trainType}} -->
        </el-col>
        <el-col :span="4" >
            <!-- <span class="hand" @click="exit">
              首页
            </span> -->
            <router-link to='/' class="goIndex">首页</router-link>

            <span class="hand" @click="exit">
              <img src="~@/assets/images/exit.png" class="exitImg" alt=""> 退出
            </span>
        </el-col>
    </el-row>
    
</template>
<script>
import { mapState } from 'vuex';
export default {
    computed :{
        ...mapState({
            userData:state => state.user.userData
        })
    },
    data(){
        return {
            
        }
    },
    methods:{
        exit(){
            this.$store.dispatch('logout');
            this.$router.push('/')
        }
    }
}
</script>
<style lang="stylus" scoped>
.welcome
    font-size 16px
    padding 32px 13px 32px 13px
    background #fff
    .goIndex
        margin-right 20px
    .hand
        cursor pointer
        .exitImg
            vertical-align middle
</style>


// WEBPACK FOOTER //
// src/components/common/exit.vue